import videojs from 'video.js';
import PluginTech from './plugin-tech';

const mergeOptions = videojs.mergeOptions;

const PLUGIN_STATE = {
  IDLE: 0,
  OPENING: 1,
  BUFFERING: 2,
  PLAYING: 3,
  PAUSED: 4,
  STOPPING: 5,
  STOPPED: 6,
  ERROR: 7
};

/**
 * Технология воспроизведения через Ace Stream Web Plugin.
 */
class Ace extends PluginTech {
  static get pluginType() {
    return 'application/x-acestream-plugin';
  }

  constructor(options, ready) {
    // Дополнительные атрибуты embed тега
    options.attributes = mergeOptions({
      type: Ace.pluginType,
      bgcolor: '#000000',
      videobgcolor: '#000000',
      fontcolor: '#ffffff',
      fullscreencontrols: '1',
      fscontrolsenable: '1',
      fscontrols: 'default',
      nofscontrolsenable: '1',
      nofscontrols: 'default',
      nofscontrolsheight: '36',
      defaultcontrolsforstream: '0',
      loopable: '0',
    }, options.attributes);

    super(options, ready);
  }

  dispose() {
    clearTimeout(this.watchPluginStateTimer);
    super.dispose();
  }

  attachPluginEvents() {
    this.watchPluginState();
  }

  /**
   * Ace Web Plugin не поддерживает событий, поэтому мы отслеживаем в цикле его состояние.
   */
  watchPluginState() {
    try {
      this.updatePluginState();
    } catch (e) {
      console.error('ace-tech: updatePluginState exception ' + e);
    }

    this.watchPluginStateTimer = setTimeout(() => this.watchPluginState(), 100);
  }

  updatePluginState() {
    if (!this.el_) {
      return;
    }

    let state;
    try {
      state = this.el_.inputState;
    }
    catch(e) {
      state = PLUGIN_STATE.ERROR;
    }

    if (this.pluginState !== state) {
      switch (state) {
        case PLUGIN_STATE.IDLE:
          break;

        case PLUGIN_STATE.OPENING:
          this.trigger('loadstart');
          break;

        case PLUGIN_STATE.BUFFERING:
          this.trigger('loadeddata');
          break;

        case PLUGIN_STATE.PLAYING:
          this.trigger('play');
          this.trigger('playing');
          break;

        case PLUGIN_STATE.PAUSED:
          this.trigger('pause');
          break;

        case PLUGIN_STATE.STOPPING:
          break;

        case PLUGIN_STATE.STOPPED:
          this.trigger('pause');
          this.trigger('ended');
          break;

        default:
        case PLUGIN_STATE.ERROR:
          this.trigger('error');
          this.trigger('ended');
          break;
      }
      this.pluginState = state;
    }
  }

  //noinspection JSUnusedGlobalSymbols
  src(src) {
    if (src === undefined) {
      return this.currentSrc();
    }

    // Setting src through `src` not `setSrc` will be deprecated
    return this.setSrc(src);
  }

  setSrc(src) {
    src = PluginTech.getAbsoluteUrl(src);
    this.el_.playlistClear();
    this.el_.playlistAdd(src);
  }

  currentSrc() {
    if (this.currentSource_) {
      return this.currentSource_.src;
    }
    else {
      // Urls added with playlistAdd method are stored in the title
      return this.el_.playlistItemTitle(this.el_.playlistCurrentItem);
    }
  }

  play() {
    this.el_.playlistPlay();
  }

  pause() {
    if (!this.paused()) {
      this.el_.playlistTogglePause();
    }
  }

  paused() {
    const state = this.el_.inputState;
    return (state === 4 /* PAUSED */ || state === 6 /* ENDED */);
  }

  currentTime() {
    return (this.el_.inputTime / 1000);
  }

  setCurrentTime(seconds) {
    this.el_.inputTime = (seconds * 1000);
  }

  duration() {
    return (this.el_.inputLength / 1000);
  }

  buffered() {
    // Not supported
    return [];
  }

  ended() {
    const state = this.el_.inputState;
    return (state === 6 /* ENDED */ || state === 7 /* ERROR */);
  }

  volume() {
    return this.el_.audioVolume / 100;
  }

  setVolume(percentAsDecimal) {
    if (percentAsDecimal) {
      this.el_.audioVolume = percentAsDecimal * 100;
    }
  }

  muted() {
    return this.el_.audioMute;
  }

  setMuted(muted) {
    if (!this.muted() && muted) {
      return this.el_.audioToggleMute();
    }
    if (this.muted() && !muted) {
      return this.el_.audioToggleMute();
    }
  }

  supportsFullScreen() {
    return true;
  }

  enterFullScreen() {
    this.el_.videoFullscreen = true;
    this.trigger('fullscreenchange');
  }

  exitFullScreen() {
    this.el_.videoFullscreen = false;
    this.trigger('fullscreenchange');
  }

  isPluginReady() {
    return 1 &&
      typeof this.el_.state !== 'undefined' &&
      typeof this.el_.inputTime !== 'undefined' &&
      typeof this.el_.inputState !== 'undefined' &&
      typeof this.el_.playlistAdd !== 'undefined' &&
      typeof this.el_.playlistPlay !== 'undefined' &&
      typeof this.el_.playlistClear !== 'undefined' &&
      typeof this.el_.audioVolume !== 'undefined';
  }

  static isSupported() {
    return super.isPluginAvailable(Ace.pluginType);
  }
}

videojs.registerTech('Ace', Ace);
export default Ace;



// WEBPACK FOOTER //
// ./src/players/ace-tech.js